var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41659 6.01005L1.89104 3.50733C2.27949 2.88285 2.97772 2.46484 3.76445 2.46484H8.68155C9.46828 2.46484 10.1616 2.87793 10.555 3.5024L7.03922 6.00021C6.5426 6.32965 5.90338 6.32966 5.41659 6.01005ZM10.8844 4.4809L7.59978 6.8116C7.17691 7.09187 6.69503 7.22948 6.21808 7.22948C5.74604 7.22948 5.27399 7.09188 4.86095 6.81652L1.5616 4.4809C1.55668 4.54482 1.55176 4.61361 1.55176 4.67754V7.62779C1.55176 8.84723 2.54501 9.84049 3.76445 9.84049H8.68155C9.90098 9.84049 10.8942 8.84723 10.8942 7.62779V4.67754C10.8942 4.61361 10.8893 4.54482 10.8844 4.4809Z",
    fill: "#234240"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.91c314c9ee3572a4720f0bb727bffe1c.svg";
export { ForwardRef as ReactComponent };